export const fechas = {
	1: {
		fecha: "2018-03-23",
		evento: "Viernes de Dolores",
		procesiones: ["Servita"],
		procesiones_hora: [["2018-03-23T19:00", "2018-03-24T00:30"]]
	},
	2: {
		fecha: "2018-03-24",
		evento: "Sábado 24",
		procesiones: [false],
		procesiones_hora: [[""]]
	},
	3: {
		fecha: "2018-03-25",
		evento: "Domingo de Ramos",
		procesiones: [
			"La Paz",
			"Las Penas",
			"Despojado",
			"Sagrada Cena",
			"Humildad y Paciencia"
		],
		procesiones_hora: [
			["2018-03-25T13:30", "2018-03-26T01:15"],
			["2018-03-25T15:15", "2018-03-25T22:45"],
			["2018-03-25T15:00", "2018-03-26T02:00"],
			["2018-03-25T17:30", "2018-03-26T00:25"],
			["2018-03-25T19:10", "2018-03-26T00:50"]
		]
	},
	4: {
		fecha: "2018-03-26",
		evento: "Lunes Santo",
		procesiones: ["Nazareno del Amor", "Prendimiento", "La Palma", "Vera Cruz"],
		procesiones_hora: [
			["2018-03-26T16:30", "2018-03-26T23:30"],
			["2018-03-26T16:05", "2018-03-27T00:40"],
			["2018-03-26T15:45", "2018-03-27T01:25"],
			["2018-03-26T19:25", "2018-03-27T01:10"]
		]
	},
	5: {
		fecha: "2018-03-27",
		evento: "Martes Santo",
		procesiones: ["Sanidad", "Piedad", "Caído", "Columna", "Ecce Homo"],
		procesiones_hora: [
			["2018-03-27T16:45", "2018-03-27T23:30"],
			["2018-03-27T17:30", "2018-03-28T00:15"],
			["2018-03-27T17:50", "2018-03-28T00:30"],
			["2018-03-27T18:10", "2018-03-27T00:50"]
		]
	},
	6: {
		fecha: "2018-03-28",
		evento: "Miércoles Santo",
		procesiones: ["Las Aguas", "Sentencia", "Cigarreras", "Angustias"],
		procesiones_hora: [
			["2018-03-28T15:45", "2018-03-29T01:50"],
			["2018-03-28T17:10", "2018-03-29T02:30"],
			["2018-03-28T18:00", "2018-03-29T03:00"],
			["2018-03-28T19:40", "2018-03-29T01:15"]
		]
	},
	7: {
		fecha: "2018-03-29",
		evento: "Jueves Santo",
		procesiones: [
			"Afligidos",
			"Oración en el Huerto",
			"Nazareno",
			"Medinaceli",
			"Descendimiento"
		],
		procesiones_hora: [
			["2018-03-29T18:00", "2018-03-30T00:00"],
			["2018-03-29T17:00", "2018-03-30T04:00"],
			["2018-03-29T20:00", "2018-03-30T06:00"],
			["2018-03-29T22:35", "2018-03-30T05:55"]
		]
	},
	8: {
		fecha: "2018-03-30",
		evento: "Viernes Santo",
		procesiones: ["El Perdón", "Siete Palabras", "Expiración", "Buena Muerte"],
		procesiones_hora: [
			["2018-03-30T00:10", "2018-03-30T09:45"],
			["2018-03-30T18:15", "2018-03-31T01:15"],
			["2018-03-30T18:15", "2018-03-31T03:30"],
			["2018-03-30T21:20", "2018-03-31T02:10"]
		]
	},
	9: {
		fecha: "2018-03-31",
		evento: "Sábado Santo",
		procesiones: ["Ecce Mater Tua", "Soledad"],
		procesiones_hora: [
			["2018-03-31T01:00", "2018-03-31T03:45"],
			["2018-03-31T15:00", "2018-03-31T22:00"]
		]
	},
	10: {
		fecha: "2018-04-01",
		evento: "Domingo de Resurrección",
		procesiones: ["Resucitado"],
		procesiones_hora: [["2018-04-01T16:30", "2018-04-01T20:30"]]
	}
};



// WEBPACK FOOTER //
// ./src/data/fechas.js